import React, { useState, useEffect, useCallback } from 'react'
import { Table } from 'react-bootstrap'
import API from '../../../service/api'
import './ActiveUsers.css'

const ActiveUsers = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchActiveUsers = useCallback(async () => {
    try {
      setLoading(true)
      const res = await API({ url: '/user/active-users', method: 'GET', manageLoader: false })
      setUsers(res?.data?.data || [])
    } catch (err) {
      console.error('Failed to fetch active users', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchActiveUsers()
    const interval = setInterval(fetchActiveUsers, 60000) // refresh every 60s
    return () => clearInterval(interval)
  }, [fetchActiveUsers])

  const getTimeDiff = (lastActive) => {
    if (!lastActive) return '-'
    const diff = Math.floor((Date.now() - new Date(lastActive).getTime()) / 60000)
    if (diff < 1) return 'Just now'
    if (diff < 60) return `${diff} min ago`
    return `${Math.floor(diff / 60)}h ${diff % 60}m ago`
  }

  return (
    <div className='active-users-container'>
      <div className='active-users-header'>
        <h5 className='active-users-title'>Active Users</h5>
        <div className='active-users-stats'>
          <span className='active-users-count'>{users.length} online</span>
          <button className='active-users-refresh-btn' onClick={fetchActiveUsers} disabled={loading}>
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>
      </div>

      <div className='active-users-table-wrapper'>
        <Table bordered hover size='sm' className='active-users-table'>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Department</th>
              <th>Location</th>
              <th>Status</th>
              <th>Last Active</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 && !loading && (
              <tr><td colSpan={8} className='text-center'>No active users</td></tr>
            )}
            {loading && users.length === 0 && (
              <tr><td colSpan={8} className='text-center'>Loading...</td></tr>
            )}
            {users.map((u, i) => (
              <tr key={u._id}>
                <td>{i + 1}</td>
                <td>{u.name || '-'}</td>
                <td>{u.email || '-'}</td>
                <td>{u.roleName || '-'}</td>
                <td>{u.departmentName || '-'}</td>
                <td>{u.location || '-'}</td>
                <td>
                  <span className='active-users-dot'></span> Online
                </td>
                <td>{getTimeDiff(u.lastActiveAt)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default ActiveUsers
